import React, { useState } from 'react';
import { Menu, X, ShoppingCart } from 'lucide-react';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <header className="bg-white shadow-gruns sticky top-0 z-50">
            <nav className="container-custom">
                <div className="flex items-center justify-between h-16">
                    {/* Logo */}
                    <div className="flex-shrink-0">
                        <a href="/" className="text-2xl font-bold text-gruns-green">
                            grüns
                        </a>
                    </div>

                    {/* Desktop Navigation */}
                    <div className="hidden md:flex items-center space-x-8">
                        <a href="/shop" className="text-gray-700 hover:text-gruns-green">Shop</a>
                        <a href="/learn" className="text-gray-700 hover:text-gruns-green">Learn</a>
                        <a href="/connect" className="text-gray-700 hover:text-gruns-green">Connect</a>
                        <button className="btn-primary">Try grüns →</button>
                        <a href="/cart" className="text-gray-700 hover:text-gruns-green">
                            <ShoppingCart size={24} />
                        </a>
                    </div>

                    {/* Mobile menu button */}
                    <div className="md:hidden">
                        <button
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            className="text-gray-700 hover:text-gruns-green"
                        >
                            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
                        </button>
                    </div>
                </div>

                {/* Mobile Navigation */}
                {isMenuOpen && (
                    <div className="md:hidden">
                        <div className="px-2 pt-2 pb-3 space-y-1">
                            <a href="/shop" className="block px-3 py-2 text-gray-700 hover:text-gruns-green">Shop</a>
                            <a href="/learn" className="block px-3 py-2 text-gray-700 hover:text-gruns-green">Learn</a>
                            <a href="/connect" className="block px-3 py-2 text-gray-700 hover:text-gruns-green">Connect</a>
                            <button className="w-full btn-primary mt-2">Try grüns →</button>
                        </div>
                    </div>
                )}
            </nav>
        </header>
    );
};

export default Header; 